/**
 * The pack counts a top-up picker offers. Fixed steps rather than every count up to a plan's limit,
 * so the choices read as round amounts (10,000 / 20,000 / 50,000 ...). Instant top-up and auto
 * top-up both offer these, so the two pickers can't drift apart.
 */
export const TOP_UP_PACK_QUANTITIES: number[] = [1, 2, 5, 10, 20];

/**
 * The steps a plan's pack rules allow, smallest first. A limit between steps (say 7) offers the
 * step below it. Manual buying passes minQty 1; auto top-up passes the plan's autoModeMinQty.
 */
export const deriveTopUpPackQuantities = (params: {
	minQty: number
	maxQty: number // The plan's oneTimeTopUp.maxQty, which the server enforces on both kinds of top-up
}): number[] => {
	const { minQty, maxQty } = params;
	return TOP_UP_PACK_QUANTITIES.filter((qty: number) => qty >= minQty && qty <= maxQty);
};
